import { useEffect, useState } from "react";
import "./patientFullView.css";
import Icons from "../../Assets/Icons";
import { useTranslation } from "react-i18next";
import moment from "moment";

const PatientPersonalInfo = ({ data }) => {
  const { t } = useTranslation();
  const [profilePhoto, setProfilePhoto] = useState(Icons.noProfile);

  useEffect(() => {
    const img = data?.profilePhoto || Icons.noProfile;
    setProfilePhoto(img);
  }, [data?.profilePhoto]);

  return (
    <div className="pdl-info">
      <p className="pdl-title">{t("personalInformation")}</p>
      <div className="pdl-body">
        <div className="pdl-section-left">
          <img src={profilePhoto || Icons.noProfile} alt="profile" />
          <section className="pdl-hn ppi-hn">
            <p className="pdl-hn-title">{t("hnNumber")}</p>
            <p className="pdl-number ppi-hnNum">{data?.hnNumber}</p>
          </section>
        </div>
        <div className="pdl-section-right">
          <section>
            <p className="ppi-name">
              {data?.firstName} {data?.lastName}
            </p>
          </section>
          <section className="pdl-phone-dob ppi-dob">
            <div className="pdl-detail">
              <img src={Icons.gender} alt="mail" />
              <span>{t(data?.gender)}</span>
            </div>
            <div className="pdl-detail">
              <img src={Icons.CalenderIcon} alt="calender" />
              <span>{moment(data?.dateOfBirth).format("DD/MM/YYYY")}</span>
            </div>
          </section>
          <section className="pdl-phone-dob ppi-email">
            <div className="pdl-detail">
              <img src={Icons.Call} alt="call" />
              <span>{data?.countryCode + " " + data?.phoneNumber}</span>
            </div>
            {data?.email && (
              <div className="pdl-detail">
                <img src={Icons.SmsIcon} alt="mail" />
                <span>{data?.email}</span>
              </div>
            )}
          </section>
          <section className="pdl-detail">
            <img src={Icons.insurance} alt="mail" />
            <span>{t(data?.insuranceCategory)}</span>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PatientPersonalInfo;
